//for refactoring, separate to related to different files
//eg security, awsS3, statusCodes
//then move to helpers folder

import store from '@/store'
import common_data from '@/common/data'
import dbresults from '@/common/dbresults.js'

export default {
    //****************************************************************************************/
    //TODO, the first 3 methods are already transferred to helpers/access-permissions.js
    //with improved version, just need to replace instances of those methods then test
    getMatchedAccessRights(currentPath) {
        var match = []
        if (store.state.user_apps_list) {
            store.state.user_apps_list.every(item => {
                match = item.appPages.filter(x => {
                    //note. don't use includes. should search from root path
                    return currentPath.startsWith(x.pagePath)
                })
                if (match.length) return false //stops the forEach loop. does not work in forEach
                return true                      //return true if not found so that the loop continues
            })
        }
        return match
    },
    hasEditRights(currentPath) {
        var matched = this.getMatchedAccessRights(currentPath)
        if (matched.length) return matched[0].accessRights.edit
        return false
    },
    hasApproverRights(currentPath) {
        var matched = this.getMatchedAccessRights(currentPath)
        if (matched.length) return matched[0].accessRights.approver
        return false
    },
    //****************************************************************************************/


    //****************************************************************************************/
    //transfer the following to helpers/status-helpers.js
    getStatusDescription(statusCode) {
        return common_data.status_codes.filter(x => {
            return x.statusCode == statusCode
        })[0].statusDescription
    },
    getStatusCode(statusDescription) {
        return common_data.status_codes.filter(x => {
            return x.statusDescription == statusDescription
        })[0].statusCode
    },
    getStatusColor(statusCode) {
        return common_data.status_codes.filter(x => {
            return x.statusCode == statusCode
        })[0].color
    },
    getStatusColorByDesc(statusDescription) {
        var data = common_data.status_codes.filter(x => {
            return x.statusDescription == statusDescription
        })
        
        if (data.length > 0) return data[0].color
        else {
            var data = common_data.description_colors.filter(x => {
                return x.statusDescription == statusDescription
            })
            if (data.length > 0) return data[0].color
            return ''
        }
    },
    getStatusButtonColor(statusCode) {
        return common_data.status_codes.filter(x => {
            return x.statusCode == statusCode
        })[0].buttonColor
    },
    //****************************************************************************************/


    //check if the following 2 are still being used
    validateDBResponse(code){
        return dbresults.db_errors.filter(x => {
            return x.code==code
        })[0].description
    },
    getSalaryTypeName(salaryType) {
        return common_data.salary_types.filter(x => x.salaryType == salaryType)[0].name
    },

    //****************************************************************************************/
    //TODO - these are transferred to helpers/aws-s3.js
    //     - but some codes are still pointing to this function.js
    //     - need to review each function and must reference to aws-s3
    getAvatarUrl(userIdStr) {
        return `${process.env.VUE_APP_UPLOAD_URL}${store.state.companyAccount.accountNumber}/avatars/${userIdStr}/thumb.jpg`
    },
    getProfileAvatarUrl(userIdStr) {
        return `${process.env.VUE_APP_UPLOAD_URL}${store.state.companyAccount.accountNumber}/avatars/${userIdStr}/profile.jpg`
    },
    getAttendanceThumbPicUrl(userIdStr, transDate, action) {
        return `${process.env.VUE_APP_UPLOAD_URL}${store.state.companyAccount.accountNumber}/attendance/${userIdStr}/${transDate}/${action}/thumb.jpg`
    },
    getAttendancActualPicUrl(userIdStr, transDate, action) {
        return `${process.env.VUE_APP_UPLOAD_URL}${store.state.companyAccount.accountNumber}/attendance/${userIdStr}/${transDate}/${action}/actual.jpg`
    },
    getCompanyLogoUrl() {
        return `${process.env.VUE_APP_UPLOAD_URL}${store.state.companyAccount.accountNumber}/company-logo/${store.state.companyLogo}`
    },
    getCompanyLogoUrlByAccount(accountNumber, fileName) {
        return `${process.env.VUE_APP_UPLOAD_URL}${accountNumber}/company-logo/${fileName}`
    },
    getFaceAIPhoto(fileName) {
        return `${process.env.VUE_APP_UPLOAD_URL}${store.state.companyAccount.accountNumber}/face-ai/${fileName}`
    },
    getReimbursementAttachment(userId, fileName) {
        return `${process.env.VUE_APP_UPLOAD_URL}${store.state.companyAccount.accountNumber}/reimbursements/${userId}/${fileName}`
    },
    //****************************************************************************************/
}